<template>
  <div class="tt-no-data">
    <icon name="no-data" />
    <span>{{ text }}</span>
  </div>
</template>
<script>
import Icon from 'com/Icon'

export default {
  name: 'NoData',
  components: {
    Icon
  },
  props: {
    text: String
  }
}
</script>
<style lang="less">
.tt-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  height: 100%;
  color: var(--light-grey);
  svg {
    width: 53px;
    height: 58px;
    margin: -40px 0 10px;
    color: var(--light-grey);
  }
}
</style>
